import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import Box from '@mui/material/Box';
import ExpandCircleDownIconSharp from '@mui/icons-material/ExpandCircleDown';
import PromotionCard from 'bento-ordering/promotions/components/PromotionsCard';
import { getMenuItemNamesColor } from 'styles/helpers/getThemeStyles';

const StyledCircleIcon = styled(ExpandCircleDownIconSharp)(({ theme }) => ({
  fill: getMenuItemNamesColor(theme),
  '&.swiper-button-next': {
    transform: 'rotate(-90deg)',
    '&.swiper-button-disabled': {
      display: 'none'
    }
  },
  '&.swiper-button-prev': {
    transform: 'rotate(90deg)',
    '&.swiper-button-disabled': {
      display: 'none'
    }
  }
}));

function PromotionCardSlider({ promotions, isMobile, isTablet }) {
  let slidesPerView = 3.4;
  if (isMobile) {
    slidesPerView = 1.1;
  } else if (isTablet) {
    slidesPerView = 2.2;
  }

  return (
    <Swiper
      modules={[Navigation]}
      navigation={{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }}
      slidesPerView={slidesPerView}
      centeredSlides
      centeredSlidesBounds
      normalizeSlideIndex={false} // to ensure mobile initial load starts with index 0 instead of 1
      spaceBetween={16}
      data-testid="promos-swiper"
      aria-label="promos-swiper"
      style={{ padding: '16px 0' }}
    >
      <StyledCircleIcon
        className=" swiper-button-prev"
        data-testid="prev-promos-button"
        aria-label="prev-promos-button"
      />
      {promotions.map(promotion => (
        <SwiperSlide key={promotion.id} data-testid="promos-swiper-slide">
          <Box height="100%">
            <PromotionCard promotion={promotion} />
          </Box>
        </SwiperSlide>
      ))}
      <StyledCircleIcon
        className=" swiper-button-next"
        data-testid="next-promos-button"
        aria-label="next-promos-button"
      />
    </Swiper>
  );
}

PromotionCardSlider.propTypes = {
  promotions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      selfhosted_style: PropTypes.number,
      promotion: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string
      })
    })
  ),
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool
};

export default PromotionCardSlider;
